<template>
  <section class="p-seo c-section">
    <div v-if="isLoading" class="l-block__content">
      <Loading variant="inline" />
    </div>
    <template v-else>
      <ListIssues
        category="seo"
        :items="items.seo"
        :project="project"
        :hasTaskForm="hasTaskForm"
      >
        <slot>一般的なSEO問題</slot>
      </ListIssues>
      <ListIssues
        category="speed"
        :items="items.speed"
        :project="project"
        :hasTaskForm="hasTaskForm"
      >
        <slot>スピード最適化</slot>
      </ListIssues>
      <ListIssues
        category="serverAndSecurity"
        :items="items.serverAndSecurity"
        :project="project"
        :hasTaskForm="hasTaskForm"
      >
        <slot>サーバー＆セキュリティ</slot>
      </ListIssues>
      <ListIssues
        category="mobileUsability"
        :items="items.mobileUsability"
        :project="project"
        :hasTaskForm="hasTaskForm"
      >
        <slot>モバイルユーザビリティ</slot>
      </ListIssues>
      <ListIssues
        category="advancedSeo"
        :items="items.advancedSeo"
        :project="project"
        :hasTaskForm="hasTaskForm"
      >
        <slot>高度なSEO</slot>
      </ListIssues>
    </template>
  </section>
</template>

<script>
import { SEO_CHECKUP_ITEM } from '@/constants';
import ListIssues from '@/components/seo/ListIssues';
import Loading from '@/components/Loading';

export default {
  props: {
    issues: {
      type: Array,
      required: true
    },
    project: {
      type: Object,
      required: true
    },
    url: {
      type: String,
      required: true
    },
    isLoading: {
      type: Boolean,
      required: true
    }
  },
  components: {
    ListIssues,
    Loading
  },
  computed: {
    items() {
      const items = {
        seo: [],
        speed: [],
        serverAndSecurity: [],
        mobileUsability: [],
        advancedSeo: []
      };
      for (let i = 0; i < this.issues.length; i++) {
        const issue = this.issues[i];
        const itemData = SEO_CHECKUP_ITEM[issue.id];
        issue.url = this.url;
        if (itemData) {
          issue.label = itemData.label;
          issue.score = itemData.score;
        }
        items[issue.category].push(issue);
      }
      return items;
    },
    hasTaskForm() {
      const projectUrl = this.$options.filters.removeTrailingSlash(
        this.project.siteUrl
      );
      return this.url.indexOf(projectUrl) === 0;
    }
  }
};
</script>
